import React, { useEffect, useState } from 'react';
// import GeneralNavbar from '../../Header';
import GeneralNavbar from '../Header';
import Footer from '../Footer';
import '../css/presale.css'
import '../css/aboutus.css'
import Banner from '../Presale/Banner';
import { FaLinkedin } from "react-icons/fa";
import { Fade, Zoom } from 'react-reveal';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import Community from '../../community';
// import { Header } from 'antd/es/layout/layout';
import Header from '../../Header';


const Aboutus = () => {

    return (
        <>
            <Header />
            {/* <section className='bg-dark py-5'>
                <Container>
                    <Row>
                        <Col lg={12} className='text-center'>
                            <div className='heading'>
                               <h1 class="text-primary"><b>About Us</b></h1>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}


            <section className='aboutus py-5 mb-4'>
                <Container>
                    <Row className='justify-content-center' style={{ minHeight: "1px" }} >
                        <Col lg={12} className='text-center'>
                            <div className="about-content">
                                <div className='mb-5'>
                                    <h1 className="text-uppercase mb-2">
                                        <span className="text-primary fw-bold fs-1">About our company</span>
                                    </h1>
                                    <p className='text-primary fs-4'>INFI MultiChain CDEX operates as a branch of Inverted Investment, providing a reliable, transparent, and decentralised digital multi-chain trading platform. The platform's native currency, INFI, forms the core of the ecosystem governed by the ©SbSe Protocol. Owning INFI entitles one to a stake in Inverted Investment. We place a high priority on investor protection through efficient liquidity management and swift response to any fraudulent activities. The SbSe PFP (SbSe Funding Pool) offers clear access to the profits of Inverted Investment.</p>
                                </div>
                                {/* <div>
                                    <img src='assets/images/aboutus.png' />
                                </div> */}

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className='ourmission py-5 mb-4'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col lg={11} className='text-center'>
                            <div className="mission-content">
                                <div className='mb-5'>
                                    <h1 className="text-uppercase mb-2">
                                        <span className="text-primary fw-bold fs-1">Our Mission</span>
                                    </h1>
                                    <p className='text-primary fs-4'>Beside all of the above, our main goal is to transition the ©SbSe Protocol into a digital payment infrastructure, integrating it into our Centralised INFI Wallet to connect traditional finance with the decentralised realm of cryptocurrencies. This evolution aims to establish a cost-effective, energy-efficient system that reduces waste and provides financial benefits to both clients and users. To realise this vision, we have assembled a team of experienced, skilled, and dynamic professionals dedicated to implementing and enhancing the INFI network.Moreover, this advancement represents the upgrade that the WEB3 necessitates, introducing the new concept of WEB4!</p>
                                </div>

                            </div>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col lg={4} md={6} xs={12} className='mb-4'>
                            <Card className='cardBox text-center p-4'>
                                <div className="mb-4 icon-img pt-4">
                                    <img src="assets/images/ourmission/coin-sync.png" width={`70px`} />
                                </div>
                                <h2 className='fw-bold'>Transparency</h2>
                                <p className='text-primary fs-4'>Cras es semper neque, sit amet aliquet odio. Donce volupat enim quis mollis consequat,</p>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} xs={12} className='mb-4'>
                            <Card className='cardBox text-center p-4'>

                                <div className="mb-4 icon-img pt-4">
                                    <img src="assets/images/ourmission/users.png" width={`70px`} />
                                </div>
                                <h2 className='fw-bold'>Experience Team</h2>
                                <p className='text-primary fs-4'>Cras es semper neque, sit amet aliquet odio. Donce volupat enim quis mollis consequat,</p>
                            </Card>
                        </Col>
                        <Col lg={4} md={6} xs={12} className='mb-4'>
                            <Card className='cardBox text-center p-4'>
                                <div className="mb-4 icon-img pt-4">
                                    <img src="assets/images/ourmission/security.png" width={`70px`} />
                                </div>
                                <h2 className='fw-bold'>Security Guarantee</h2>
                                <p className='text-primary fs-4'>Cras es semper neque, sit amet aliquet odio. Donce volupat enim quis mollis consequat,</p>
                            </Card>
                        </Col>
                    </Row> */}
                </Container>
            </section>
            <section className='ourteam pb-5 mb-4'>
                <Container>
                    <Row className='justify-content-center'>
                        <Col lg={10} className='text-center'>
                            <div className="mission-content">
                                <div className='mb-5'>
                                    <h1 className="text-uppercase mb-2">
                                        <span className="text-primary fw-bold fs-1">Our Team</span>
                                    </h1>
                                    <p className='mb-1 text-primary fs-4'>What makes us unique is the way we do and the way we think! Revolutionizing Everything with our Decentralized System, Passive Income Reward Scheme, and SbSe Protocol.</p>
                                    <p className='mb-1 text-primary fs-4'>Not only do we have a highly-skilled development team, but we possess the passion and talent to make a difference. We're "crazy" enough to believe that we can change the world, and we're determined to make it happen!</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    </Container>
                    </section>

<Community />

<Footer />
</>
)
}
//                     <Row>
//                         <Col lg={4} md={6} xs={12} className='mb-4'>
//                             <Card className='cardBox text-left p-0'>
//                                 <div className='overflow-hidden' style={{ borderRadius: "9px" }}>
//                                     {/* <div className="mb-2 team-img">
//                                         <img src="assets/images/about/teamImg1.jpg" alt='teamImg1' className='teamImg' />
//                                     </div> */}
//                                     <Card.Body className="p-3">
//                                         <h3>Ödön Oszkár Horváth</h3>
//                                         <div className='mt-3 d-flex justify-content-between align-items-center'>
//                                             <h6 className='fs-4 mb-0'>CEO</h6> <span><FaLinkedin className='inkedingIcon' /></span>
//                                         </div>
//                                     </Card.Body>
//                                 </div>
//                             </Card>
//                         </Col>
//                         <Col lg={4} md={6} xs={12} className='mb-4'>
//                             <Card className='cardBox text-left p-0'>
//                                 <div className='overflow-hidden' style={{ borderRadius: "9px" }}>
//                                     <div className="mb-2 team-img">
//                                         <img src="assets/images/about/teamImg2.jpg" alt='teamImg2' className='teamImg' />
//                                     </div>
//                                     <Card.Body className="p-3">
//                                         <h3>Sven Schönwald</h3>
//                                         <div className='mt-3 d-flex justify-content-between align-items-center'>
//                                             <h6 className='fs-4 mb-0'>Co-Founder Head of Europe</h6> <span><FaLinkedin className='inkedingIcon' /></span>
//                                         </div>
//                                     </Card.Body>
//                                 </div>
//                             </Card>
//                         </Col>
//                         {/* <Col lg={4} md={6} xs={12} className='mb-4'>
//                             <Card className='cardBox text-left p-0'>
//                                 <div className='overflow-hidden' style={{ borderRadius: "9px" }}>
//                                     <div className="mb-2 team-img">
//                                         <img src="assets/images/about/teamImg3.png" alt='teamImg3' className='teamImg' />
//                                     </div>
//                                     <Card.Body className="p-3">
//                                         <h3>Ernest Erwin</h3>
//                                         <div className='mt-3 d-flex justify-content-between align-items-center'>
//                                             <h6 className='fs-4 mb-0'>Head of Global Marketing</h6> <span><FaLinkedin className='inkedingIcon' /></span>
//                                         </div>
//                                     </Card.Body>
//                                 </div>
//                             </Card>
//                         </Col> */}

//                         <Col lg={4} md={6} xs={12} className='mb-4'>
//                             <Card className='cardBox text-left p-0'>
//                                 <div className='overflow-hidden' style={{ borderRadius: "9px" }}>
//                                     <div className="mb-2 team-img">
//                                         <img src="assets/images/about/teamImg4.jpg" alt='teamImg4' className='teamImg' />
//                                     </div>
//                                     <Card.Body className="p-3">
//                                         <h3>Géza Fekete</h3>
//                                         <div className='mt-3 d-flex justify-content-between align-items-center'>
//                                             <h6 className='fs-4 mb-0'>CTO - Head of Expansion Europe</h6> <span><FaLinkedin className='inkedingIcon' /></span>
//                                         </div>
//                                     </Card.Body>
//                                 </div>
//                             </Card>
//                         </Col>

//                     </Row>
//                     <Row>

//                         <Col lg={4} md={6} xs={12} className='mb-4'>
//                             <Card className='cardBox text-left p-0'>
//                                 <div className='overflow-hidden' style={{ borderRadius: "9px" }}>
//                                     <div className="mb-2 team-img">
//                                         <img src="assets/images/about/teamImg5.jpg" alt='teamImg5' className='teamImg' />
//                                     </div>
//                                     <Card.Body className="p-3">
//                                         <h3>Éva Meggyesi</h3>
//                                         <div className='mt-3 d-flex justify-content-between align-items-center'>
//                                             <h6 className='fs-4 mb-0'>Co-Founder Head of Growth</h6> <span><FaLinkedin className='inkedingIcon' /></span>
//                                         </div>
//                                     </Card.Body>
//                                 </div>
//                             </Card>
//                         </Col>
//                         <Col lg={4} md={6} xs={12} className='mb-4'>
//                             <Card className='cardBox text-left p-0'>
//                                 <div className='overflow-hidden' style={{ borderRadius: "9px" }}>
//                                     <div className="mb-2 team-img">
//                                         <img src="assets/images/about/teamImg6.jpg" alt='teamImg6' className='teamImg' />
//                                     </div>
//                                     <Card.Body className="p-3">
//                                         <h3>Tamás Varga</h3>
//                                         <div className='mt-3 d-flex justify-content-between align-items-center'>
//                                             <h6 className='fs-4 mb-0'>Head of Partnerships Europe</h6> <span><FaLinkedin className='inkedingIcon' /></span>
//                                         </div>
//                                     </Card.Body>
//                                 </div>
//                             </Card>
//                         </Col>

//                     </Row>
//                 </Container>
//             {/* </section>

//             <Community />

//             <Footer />
//         </>
//     )
// } */}

export default Aboutus
